import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEmail2Remove: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconEmail2Remove"><Path fillRule="evenodd" clipRule="evenodd" d="M22 9.11816L12 14.1182L4 10.1172V18H12V20H2V4H22V9.11816Z" fill="currentColor"/><Path d="M22.957 14.957L20.6641 17.25L22.957 19.543L21.543 20.957L19.25 18.6641L16.957 20.957L15.543 19.543L17.8359 17.25L15.543 14.957L16.957 13.543L19.25 15.8359L21.543 13.543L22.957 14.957Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEmail2Remove;
